import { useState, type ReactNode } from 'react';
import { PanelTitleContext } from './panelTitleCtx';

export function PanelTitleProvider({ children }: { children: ReactNode }) {
  const [panelTitle, setPanelTitle] = useState<ReactNode | null>(null);

  return (
    <PanelTitleContext.Provider value={{ panelTitle, setPanelTitle }}>
      {children}
    </PanelTitleContext.Provider>
  );
}
